// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7a2ec00a","453":"786a9bca","455":"c8f031af"}[chunkId] + ".chunk.js";
};